
import validator from 'validator';

export function validateContactWritingForm(form, options = {}) {
    const { isEditMode = false } = options;
    const errors = {};
    
    // Safely check and trim string values
    if (!form.writerName || !form.writerName.trim()) errors.writerName = "이름을 입력해주세요";
    if (!form.title || !form.title.trim()) errors.title = "제목을 입력해주세요";
    if (!form.boardContent || !form.boardContent.trim()) errors.content = "내용을 입력해주세요";
    if ((!form.password || !form.password.trim())) {
        if (!isEditMode) {
            errors.password = "비밀번호를 입력해주세요";
        }
    } else if (!/^[a-zA-Z0-9]+$/.test(form.password)) errors.password = "비밀번호는 영문자와 숫자만 입력 가능합니다";
    if (!form.email || !form.email.trim()) errors.email = "이메일을 입력해주세요";
    else if (!validator.isEmail(form.email)) errors.email = "올바른 이메일 형식을 입력해주세요";
    // if (!validFiles || !validFiles.length) errors.files = "파일을 추가해주세요";
    return errors;
} 